import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";
import applicationReducer from "./applicationReducer";
import noticeReducer from "./noticeReducer";
import reviewReducer from "./reviewReducer";
import declineReducer from "./declineReducer";
import addExistingReducer from "./addExistingReducer";
import createAdminReducer from "./createAdminReducer";
import addProfileReducer from "./addProfileReducer";
import addClassReducer from "./addClassReducer";
import deleteClassReducer from "./deleteClassReducer";
import addResultReducer from "./addResultReducer";
import addFeesReducer from "./addFeesReducer";
import signUpReducer from "./signUpReducer";
import authReducer from "./authReducer"
import addAdminEmailReducer from "./addAdminEmailReducer";

const RootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  application: applicationReducer,
  notice: noticeReducer,
  reviewApplication: reviewReducer,
  declineApplication: declineReducer,
  addExisting: addExistingReducer,
  createAdmin: createAdminReducer,
  addProfile: addProfileReducer,
  addClass: addClassReducer,
  deleteClass: deleteClassReducer,
  addResult: addResultReducer,
  addFees: addFeesReducer,
  signUp: signUpReducer,
  auth: authReducer,
  addAdminEmail: addAdminEmailReducer
});

export default RootReducer;
